import React, { useEffect, useState } from "react";
import "./Icon.css";

const IconMov = ({ imageUrl }) => {
  const [isFinished, SetIsfinished] = useState(false);

  useEffect(()=>{
    setTimeout(()=>{
      SetIsfinished(true);
    },10000)
  },[])
  return (
    <div>
      <div
        class={isFinished?"ring-icon-without":"ring-icon"}
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          justifyContent: "center",
          alignItems:'center'
        }}
      >
        <img
          src={imageUrl}
          width={75}
          height={75}
          slt="chatgpt"
          class="img-fluid"
        />
        <span></span>
      </div>
    </div>
  );
};

export { IconMov };
